import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';
import { createCSV, forceDownload } from './create_csv';
import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/storage_bills', {
        template: require('./storage_bills.html'),
        controller: 'StorageBillsController'
    });
})
.controller('StorageBillsController', function($scope, $location, StorageBill, $filter, $q) {
    canFilter($scope, $location);
    canPaginate($scope, $location);
    $scope.s || ($scope.s = 'starts_at,account_name');
    $scope.q || ($scope.q = '');
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.loading = true;

    const params = _.pick($scope, 'q', 's', 'p');

    if (!$scope.f.charged && !$scope.f.uncharged) {
      // status not supported by API ... default to uncharged
      $scope.f.uncharged = true;
    }
    if ($scope.f.charged && !$scope.f.uncharged) {
      params['filter.charged'] = 'true';
    }
    if ($scope.f.uncharged && !$scope.f.charged) {
      params['filter.charged'] = 'false';
    }
    params['filter.is_archived'] = 'false';

    $scope.storageBills = StorageBill.query(params, function(data, getResponseHeader) {
        $scope.loading = false;
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });

    $scope.charge = (bill) => {
        bill.__charging__ = true;
        const method = bill.account_payment_status == 'manual' ? 'manual' : 'stripe';
        StorageBill.charge({id: bill.id, method: method}, null, (data) => {
            bill.__charging__ = false;
            bill.stripe_charge_id = data.stripe_charge_id;
        });
    };

    $scope.delete = (bill) => {
      if (!confirm(`Are you sure you want to delete the bill for ${bill.account_name}? This cannot be undone.`)) {
        return;
      }
      StorageBill.delete({id: bill.id}, null, (data) => {
        $scope.storageBills.splice($scope.storageBills.indexOf(bill), 1);
      });
    };

    $scope.generateCSV = () => {
      $scope.generatingCSV = true;
      $scope.getAllStorageBills('charged:false').then((result) => {
        const bills = result;
        forceDownload(createCSV(bills, $filter));
        $scope.generatingCSV = false;
        $scope.generatedCSV = true;
      });
    };

    $scope.getAllStorageBills = (filter = '', pageSize = 1000) => {
      var allStorageBills = [];
      return $q((resolve, reject) => {
        var page = 0;
        const queryStorageBills = () => {
          const query = angular.extend({}, _.pick($scope, 's'), {
            q: filter,
            p: page,
            l: pageSize,
            'filter.is_archived': 'false',
          });
          StorageBill.query(query, (data, headers) => {
            allStorageBills = allStorageBills.concat(data);
            var pagination = JSON.parse(headers('X-Pagination')) || {};
            if (!pagination.last || page >= pagination.last || data.length == 0) {
              resolve(allStorageBills);
            } else {
              page++;
              queryStorageBills();
            }
          }, (err) => {
            reject(err);
          });
        }
        queryStorageBills();
      });
    }

    $scope.accountUrl = bill => `${NEW_ADMIN_URL}/accounts/${bill.account_id}`;

    $scope.showUrl = bill => `${NEW_ADMIN_URL}/storage-bills/${bill.id}`;
});


// WEBPACK FOOTER //
// ./views/storage_bills/storage_bills_controller.js